import service from './config.api';
export const PROGRAMS_ENDPOINT = 'configurations/admin/programs';
export const PROGRAM_ENDPOINT = programId =>
  `${PROGRAMS_ENDPOINT}/${programId}`;

// endpoints
service.getProgram = async programId => {
  const response = await service.get(PROGRAM_ENDPOINT(programId));
  return response.data;
};

service.getPrograms = async params => {
  const response = await service.get(PROGRAMS_ENDPOINT, { params: params });
  return response.data;
};

service.deleteProgram = async programId => {
  const response = await service.delete(PROGRAM_ENDPOINT(programId));
  return response.data;
};

service.createProgram = async program => {
  const response = await service.post(PROGRAMS_ENDPOINT, program);
  return response.data;
};

service.updateProgram = async (programId, program) => {
  const response = await service.patch(PROGRAM_ENDPOINT(programId), program);
  return response.data;
};

export default service;
